import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import NotificationArea from 'components/CustomComponents/NotificationArea'
import JivositeWidget from 'components/CustomComponents/JivositeWidget'
import {setUpdatingContent, getCurrentUser, getAccessToken, getUser} from 'ducks/app'
import _, {isEmpty} from 'lodash'
import Conpass from "../../ConpassScript";
import l8n from 'l8n'
import axios from 'axios'

const mapStateToProps = (state, props) => ({
  isUpdatingContent: state.app.isUpdatingContent,
  user: getCurrentUser(state),
  token: getAccessToken(state),
})

const mapDispatchToProps = dispatch => ({
  fetchUserInfo: () => dispatch(getUser()),
  resetUpdatingContent: () => dispatch(setUpdatingContent(false)),
})

@connect(mapStateToProps, mapDispatchToProps)
class AppContent extends React.Component {
  static contextTypes = {
    getContentBuffer: PropTypes.func,
  }

  state = {
    loaded: false,
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isUpdatingContent && !nextProps.isUpdatingContent) {
      return false
    }
    return true
  }

  async componentDidMount() {
    const {token} = this.props
    if (token && token.payload) {
      axios.defaults.headers.common['Authorization'] = token.payload

      await this.props.fetchUserInfo()
    }
    this.setState({loaded: true})
  }

  componentDidUpdate() {
    const {isUpdatingContent, resetUpdatingContent} = this.props
    if (isUpdatingContent) {
      resetUpdatingContent()
    }
  }

  render() {
    const { getContentBuffer } = this.context
    const { user } = this.props
    const { content } = getContentBuffer()
    const isContentReady = ! isEmpty(content) && this.state.loaded
    const isUserLoggedIn = user && user.id

    return ! isContentReady ? (
      <div className="utils__loadingPage" />
    ) : (
      <div className="utils__content">
        {isUserLoggedIn && <NotificationArea user={user} />}
        {content}
        {window.location.pathname.match(/(.)\/login/) ? null : <JivositeWidget/>}
        {l8n.locale === 'pt' && isUserLoggedIn && (<Conpass user={user}/>)}
      </div>
    )
  }
}

export default AppContent



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Layout/Content/index.js